import { HTTP } from '@/http-common'

function getCity (cityId) {
  return HTTP.get('/cities/' + cityId)
}

function addCity (cityData) {
  let data = JSON.stringify(cityData)

  return HTTP.post('/cities', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateCity (cityData) {
  let data = JSON.stringify(cityData)

  return HTTP.put('/cities/' + cityData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteCity (cityId) {
  return HTTP.delete('/cities/' + cityId)
}

export { getCity, addCity, updateCity, deleteCity }



// WEBPACK FOOTER //
// ./src/services/city.service.js